import { set } from "lodash";
import Kithara from "src/services/kithara";
const kithara = new Kithara();

export default {
  state: {
    list: {
      loading: false,
      complete: false,
      errors: [],
      songs: [],
      nextPage: 1,
      pageSize: 40,
      filters: {
        main: "",
        tags: []
      }
    },
    editing: {
      pending: false,
      errors: [],
      song: {}
    }
  },
  mutations: {
    SONGS_LIST_CLEAN: state => {
      state.list.songs = [];
      state.list.nextPage = 1;
      state.list.complete = false;
    },
    SONGS_LIST: state => {
      state.list.loading = true;
    },
    SONGS_LIST_FILTER: (state, payload) => {
      state.list.filters = payload;
    },
    SONGS_LIST_SUCCESS: (state, payload) => {
      state.list.loading = false;
      state.list.songs = payload.songs;
      state.list.complete = payload.complete;
      state.list.nextPage++;
    },
    SONGS_LIST_FAILED: (state, payload) => {
      state.list.loading = false;
      state.list.errors = payload;
    },
    SONGS_SELECT: state => {
      state.editing.song = {};
    },
    SONGS_SET_SELECTED: (state, payload) => {
      state.editing.song = payload;
    },
    SONGS_UPDATE_SELECTED: (state, { path, value }) => {
      set(state.editing.song, path, value);
    },
    SONGS_SELECT_FAILED: () => {
      // do nothing because it should not happen
    },
    SONGS_UPDATE: state => {
      state.editing.pending = true;
    },
    SONGS_UPDATE_SUCCESS: state => {
      state.editing.pending = false;
    },
    SONGS_UPDATE_FAILED: (state, payload) => {
      state.editing.pending = false;
      state.editing.errors = payload;
    }
  },
  actions: {
    changeSongsFilter({ commit, rootState }, payload) {
      if (!payload) {
        payload = { main: rootState.route.query.filter, tags: [] };
      }
      commit("SONGS_LIST_CLEAN");
      commit("TEAM_SONGS_LIST_CLEAN");
      commit("SONGS_LIST_FILTER", payload);
      commit("TEAM_SONGS_LIST_FILTER", payload);
    },
    refreshSongs({ commit }) {
      commit("SONGS_LIST_CLEAN");
    },
    loadMoreSongs({ state, commit }) {
      if (!state.list.loading && !state.list.complete) {
        commit("SONGS_LIST");
        const { nextPage, pageSize, filters } = state.list;
        return kithara
          .getSongs(nextPage, pageSize, "title|asc", filters)
          .then(response => {
            const { data } = response.data;
            const lastPage = response.data.links.pagination.last_page;
            commit("SONGS_LIST_SUCCESS", {
              songs: state.list.songs.concat(data),
              complete: lastPage === 0 || nextPage === lastPage
            });
            return data;
          })
          .catch(err => commit("SONGS_LIST_FAILED", [err]));
      } else return [];
    },
    loadAllSongs({ state, commit }) {
      if (!state.list.loading && !state.list.complete) {
        commit("SONGS_LIST");
        const { nextPage, filters } = state.list;
        return kithara
          .getSongs(nextPage, -1, "title|asc", filters)
          .then(response => {
            const { data } = response.data;
            const lastPage = response.data.links.pagination.last_page;
            commit("SONGS_LIST_SUCCESS", {
              songs: state.list.songs.concat(data),
              complete: lastPage === 0 || nextPage === lastPage
            });
            return data;
          })
          .catch(err => commit("SONGS_LIST_FAILED", [err]));
      } else return [];
    },
    selectSong({ commit, rootState }) {
      commit("SONGS_SELECT");
      return kithara
        .getSong(rootState.route.params.id)
        .then(response => {
          commit("SONGS_SET_SELECTED", response.data);
        })
        .catch(err => commit("SONGS_SELECT_FAILED", [err]));
    },
    clearSong({ commit }) {
      commit("SONGS_SELECT");
    },
    createSong({ state, commit }) {
      commit("SONGS_UPDATE");
      return kithara
        .createSong(state.editing.song)
        .then(() => {
          commit("SONGS_UPDATE_SUCCESS");
          commit("SONGS_LIST_CLEAN");
        })
        .catch(err => commit("SONGS_UPDATE_FAILED", [err]));
    },
    saveSong({ state, commit, rootState }) {
      commit("SONGS_UPDATE");
      return kithara
        .updateSong(rootState.route.params.id, state.editing.song)
        .then(() => {
          commit("SONGS_UPDATE_SUCCESS");
          commit("SONGS_LIST_CLEAN");
        })
        .catch(err => commit("SONGS_UPDATE_FAILED", [err]));
    },
    deleteSong({ commit, rootState }) {
      commit("SONGS_UPDATE");
      return kithara
        .deleteSong(rootState.route.params.id)
        .then(() => {
          commit("SONGS_UPDATE_SUCCESS");
          commit("SONGS_SELECT");
          commit("SONGS_LIST_CLEAN");
        })
        .catch(err => commit("SONGS_UPDATE_FAILED", [err]));
    },
    updateSelectedSong({ commit }, { path, value }) {
      commit("SONGS_UPDATE_SELECTED", { path, value });
    }
  },
  getters: {
    songs: state => state.list.songs,
    songsFilter: state => state.list.filters.main,
    songsLoading: state => state.list.loading,
    songsComplete: state => state.list.complete,
    selectedSong: state => state.editing.song
  }
};



// WEBPACK FOOTER //
// ./src/store/songs.js